import React from "react";

import Logo from "../../common/images/logo.png";

import { IoMdClose } from "react-icons/io";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import { useNavigate } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { NavbarResponsive } from "../../common/components/NavbarResponsive";

export default function DocsHeader() {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  return (
    <NavbarResponsive>
      <Container>
        <Navbar.Brand>
          <img
            className="d-block"
            width={70}
            src={Logo}
            alt="Federico Bartoli PT"
          />
        </Navbar.Brand>
        <div style={{ marginLeft: "1.5rem" }}>
          <Navbar.Brand>
            <Nav
              className="back-button"
              style={{ textDecoration: "none" }}
              onClick={goBack}
            >
              <IoMdClose size={30} />
            </Nav>
          </Navbar.Brand>
        </div>
      </Container>
    </NavbarResponsive>
  );
}
